module.exports = __webpack_public_path__ + "static/media/logo-white.4e0ef144.svg";